'use client'

import { useLastViewedProdSetCookie } from '@web/hooks/use-last-viewed-prod-set-cookie'

interface PageViewEffectsProps {
  productId: string
}
export function PageViewEffects({ productId }: PageViewEffectsProps) {
  useLastViewedProdSetCookie(productId)

  return null
}
